module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_2.fa9b5f41.png";